module.exports = __webpack_public_path__ + "static/media/select-arrow.400bce57.png";